// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Fqdn } from '@gandi/ui';

import { DetailRow } from './components/Rows';

import styles from './DomainBundleDetailRow.scss';

type Props = {
  product: DecoratedProduct,
  isLast: boolean,
};

export default function DomainBundleDetailRow({
  product,
  isLast,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const label = (
    <Fqdn maxLength={42} className={styles.textBreak}>
      {product.label || ''}
    </Fqdn>
  );

  const perkDetails = __(
    'With each domain, Gandi offers you a free Single-address ' +
      'Standard SSL certificate for the 1st year ',
  );

  return <DetailRow label={label || ''} detail={isLast && perkDetails} />;
}
